import React from "react";
import { useSelector } from "react-redux";
import { formatDateToIST, getOrderStatus, getPaymentStatusColor } from "../../../../lib/utils/utils";
import StatCard from "../../../OrderDetails/Components/StatCard";

const OrderStats = () => {
  const { orderDetails } = useSelector(
    (state) => state.orderDetails.returnOrderDetails
  );
  return (
    <div className="grid grid-cols-4 gap-x-2 mx-5 mt-4">
      <StatCard
        statName={"Order Placed on"}
        statValue={formatDateToIST(orderDetails.createdAt)}
      />

      <StatCard
        statName={"Order Status"}
        statValue={getOrderStatus(orderDetails.orderStatus)}
      />

      <StatCard
        statName={"Total Price"}
        statValue={orderDetails.total}
        hasPrice={true}
        hasDecimal={true}
      />

      <StatCard
        statName={"Payment Status"}
        statValue={orderDetails.paymentStatus}
        color={getPaymentStatusColor(orderDetails.paymentStatus)}
      />
    </div>
  );
};

export default OrderStats;
